import axios from 'axios';
import config from '../../../config/Global.json';
import { loadStripe } from '@stripe/stripe-js';

export const createStripePaymentIntent = async (amount) => {
  try {
    const paymentIntentUrl = `${config.api.host}${config.api.paymentIntent}`;
    const response = await axios.post(paymentIntentUrl, {
      amount: amount,
      description: 'Subscription payment for Paisa Vara services'
    });
    
    return {
      client_secret: response.data.client_secret,
      stripe_publishable_key: response.data.stripe_publishable_key,
      amount: response.data.amount,
      currency: response.data.currency
    };
  } catch (error) {
    console.error('Error creating Stripe payment intent:', error);
    throw error;
  }
};

export const initializeStripe = async (publishableKey) => {
  return await loadStripe(publishableKey);
};

export const confirmStripePayment = async (stripe, clientSecret, paymentMethod) => {
  try {
    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: paymentMethod
    });

    if (result.error) {
      throw new Error(result.error.message);
    }

    return result.paymentIntent;
  } catch (error) {
    console.error('Error confirming Stripe payment:', error);
    throw error;
  }
};